import React, {useEffect, useState, useRef, useCallback} from 'react';
import ReactQuill, { Quill } from "react-quill-new";
import {Button} from '@mui/material';
import {Code, ModeEdit} from "@mui/icons-material";
import {getMediaBlocks, uploadFreePhoto} from "../services/api";
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { EditorView } from '@codemirror/view';

// @ts-ignore
import 'quill-paste-smart';



// @ts-ignore
// import Table from 'quill-table';
// Quill.register({
//     'modules/table': Table,
// });

// const toolbarOptions = [
//     ['bold', 'italic', 'image']
// ];
const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['link', 'image'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['clean']      ,
    // remove formatting button
];
// @ts-ignore

const ImageBlot = Quill.import('formats/image');

// @ts-ignore
class CustomImageBlot extends ImageBlot {
    static create(value:any) {
        let node = super.create(value);
        // Передаем как объект: { src, style, customAttr... }
        if (typeof value === 'object') {
            Object.keys(value).forEach(attr => {
                node.setAttribute(attr, value[attr]);
            });
        }
        return node;
    }

    static value(node:any) {
        // Собираем все атрибуты изображения в объект
        let value = {};
        node.getAttributeNames().forEach((attr: string | number) => {
            // @ts-ignore
            value[attr] = node.getAttribute(attr);
        });
        return value;
    }
}

interface EditorToggleProps {
    width: string;
    label: string;
    initialValue: string;
    onChange: (text: string) => void;
}
const EditorToggle: React.FC<EditorToggleProps> = ({
                                                       width,
                                                       label,
                                                       initialValue,
                                                       onChange
                                                   }) => {
    const [isRichText, setIsRichText] = useState(true); // Состояние для переключения режима
    const [content, setContent] = useState(''); // Содержимое редактора
    const quillRef = useRef(null);




    Quill.register('formats/image', CustomImageBlot, true);

    useEffect(() => {
        setContent(initialValue)
        onChange(initialValue);
    }, [initialValue]);


    const handleToggle = () => {
        console.log(content)
        setIsRichText(!isRichText); // Переключение между режимами
    };

    const handleContentChange = (value: string) => {
        onChange(value);
        setContent(value); // Обновление содержимого
    };
    const imageHandler = async () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const files = input.files;
            if (!files) return;
            const file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            const res = await uploadFreePhoto(formData);
            const imageUrl = res.image_url;
            // @ts-ignore
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection();
            quill.insertEmbed(range.index, 'image', imageUrl);
        };
    };
    const modules = {
        toolbar: {
            container: toolbarOptions,
            handlers: {
                image: imageHandler,
            }
        },
        clipboard: {
            allowed: {
                tags: [
                    'a', 'b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span', 'img', 'div'
                ],
                attributes: [
                    'href', 'rel', 'target', 'class', 'style', 'src', 'alt', 'width', 'height'
                ]
            },
            keepSelection: true,
            magicPasteLinks: true,
        }
    };




    return (
        <div style={{width: width}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <label>{label}</label>
                <Button onClick={handleToggle}>
                     {isRichText ? <Code/> : <ModeEdit/>}
                </Button>
            </div>


            {isRichText ? (
                <ReactQuill
                    ref={quillRef}
                    style={{width: '100%'}}
                    modules={modules}
                    theme="snow"
                    value={content}
                    onChange={handleContentChange}
                />
            ) : (
                <CodeMirror
                    value={content}
                    extensions={[html(), EditorView.lineWrapping]}
                    onChange={handleContentChange}
                    height="200px"
                    theme="light"
                />
            )}
        </div>
    );
};

export default EditorToggle;
